import {Stack, Card, ListItemText, ListSubheader, styled} from '@mui/material';

const TemplateHeader = styled('div')`
	padding: 16px;
	width: 100%;
	background-color: ${({theme}) => theme.colors.gray['20Percent']};
`;

const TemplateContainer = styled('div')`
	display: flex;
	flex-direction: column;
	flex: 1;

	${({theme}) => theme.breakpoints.up('md')} {
		flex-direction: row;
		gap: 24px;
		align-items: flex-start;
		padding: 32px;
	}
`;

const StyledCardContainer = styled(Stack)`
	justify-content: center;
	align-items: center;
	padding: 16px;
	background-color: ${({theme}) => theme.palette.primary.main};

	${({theme}) => theme.breakpoints.up('md')} {
		border-radius: 16px;
		padding: 32px;
		flex: 1;
	}
`;

const StyledCard = styled(Card)`
	border-radius: 0px;
	padding: 16px;

	${({theme}) => theme.breakpoints.up('md')} {
		border-radius: 16px;
		padding: 32px;
		display: flex;
		gap: 16px;
		flex: 2;
	}
`;

const StyledListSubheader = styled(ListSubheader)`
	font-weight: 600;
	padding-inline: 0;
	color: ${({theme}) => theme.palette.text.primary};
`;

const StyledListItemText = styled(ListItemText)`
	& .MuiListItemText-primary {
		font-size: 0.875rem;
		color: ${({theme}) => theme.palette.text.secondary};
	}

	& .MuiListItemText-secondary {
		font-size: 1rem;
		color: ${({theme}) => theme.palette.text.primary};
	}
`;

export {
	TemplateHeader,
	TemplateContainer,
	StyledCardContainer,
	StyledCard,
	StyledListSubheader,
	StyledListItemText,
};
